<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <h1 class="text-h4">
            {{ $t('caseView.title') }}
            <small class="ml-1 grey--text text--darken-1 font-weight-extra-light">
              {{ courtCase.caseNumber }}
            </small>
          </h1>
        </v-col>
      </v-row>

      <case-view-details :courtCase="courtCase" :dynamicCaseFields="dynamicCaseFields"/>

      <v-row v-if="tabs.length > 0" class="mt-8">
        <v-col cols="12">
          <v-tabs
            show-arrows
            grow
            slider-color="orange"
            class="elevation-1"
            :value="selectedTab.name">
            <v-tab v-for="tab in tabs"
                   class="primary--text"
                   style="background-color:#f0f0f0"
                   :href="tab.name"
                   @click.prevent="selectedTab = tab"
                   :key="tab.name">
              {{ $t('caseView.tab.' + tab.name) }}
            </v-tab>
          </v-tabs>
          <v-card>
            <case-view-table :case-id="caseID" :tab="selectedTab.name"/>
          </v-card>
          <div v-if="hasAccess($PACONST.COMPONENT_CASE_VIEW_SUMMARY, $PACONST.PERMISSION_TYPES.READ)"
               class="text-right mt-8">
            <router-link :to="{ name: 'caseViewSummary', params: { caseID }}" target="_blank">
              <v-btn color="primary">{{ $t('caseView.summary.summary') }}</v-btn>
            </router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import partition from 'lodash/partition';
import PAUTIL from '@/support/utility';
import PACONST from '@/support/constants';
import Cove from '@ctrack/cove';
import axios from 'axios';
import { mapGetters } from 'vuex';
import CaseViewTable from '@viewsupport/CaseViewTable';
import CaseViewDetails from '@viewsupport/CaseViewDetails';

function getCaseData (caseID) {
  let caseURL = Cove.getAPI({
    name: 'api.case',
    params: {
      caseID
    }
  });

  return axios.get(caseURL);
}

function getDynamicCaseFields (caseID) {
  let fieldsURL = Cove.getAPI({
    name: 'api.dynamicView.search',
    query: {
      caseID,
      viewID: PACONST.SYSTEM_CODE_TYPE_VIEW_TYPE
    }
  });

  return axios.get(fieldsURL);
}

export default {
  components: { CaseViewTable, CaseViewDetails },
  props: {
    caseID: {
      type: String,
      required: true
    }
  },
  methods: {
    getNestedProperty (obj, property) {
      return PAUTIL.resolvePath(obj, property);
    },
    updateTab (newTab) {
      this.selectedTab = newTab;
    }
  },
  data () {
    return {
      dynamicCaseFields: [],
      courtCase: {},
      selectedTab: { name: '' },
      tabs: []
    };
  },
  computed: {
    ...mapGetters('user', ['hasAccess']),
    _pageTitle () {
      return this.$t('caseView.title') + ' ' + this.courtCase.caseNumber;
    }
  },
  beforeRouteUpdate (to, from, next) {
    let caseDataRequest = getCaseData(to.params.caseID);
    let caseFieldsRequest = getDynamicCaseFields(to.params.caseID);

    Promise.all([caseDataRequest, caseFieldsRequest]).then(([dataResponse, fieldResponse]) => {
      this.courtCase = Object.assign({}, dataResponse.data);

      let tabs = sortBy(this.$PACONST.getTabsByCategory(this.courtCase.caseCategory), 'orderBy');
      tabs = filter(tabs, (tab) =>
      {
        return this.hasAccess(tab.componentID, this.$PACONST.PERMISSION_TYPES.READ);
      });

      let p = partition(tabs, ['name', Cove.getConfig('caseView.firstTab')]);
      this.tabs = p[0].concat(p[1]);

      // reset to first tab
      this.selectedTab = Object.assign({}, this.tabs[0]);
      this.dynamicCaseFields = sortBy(Object.assign({}, fieldResponse.data.viewFields), 'orderBy');
      next();
    });
  },
  beforeRouteEnter (to, from, next) {
    let caseDataRequest = getCaseData(to.params.caseID);
    let caseFieldsRequest = getDynamicCaseFields(to.params.caseID);

    Promise.all([caseDataRequest, caseFieldsRequest]).then(([dataResponse, fieldResponse]) => {
      next((vm) => {
        vm.courtCase = dataResponse.data;

        // preload first tab
        let tabs = sortBy(vm.$PACONST.getTabsByCategory(vm.courtCase.caseCategory), 'orderBy');
        tabs = filter(tabs, (tab) =>
        {
          return vm.hasAccess(tab.componentID, vm.$PACONST.PERMISSION_TYPES.READ);
        });

        let p = partition(tabs, ['name', Cove.getConfig('caseView.firstTab')]);
        vm.tabs = p[0].concat(p[1]);

        vm.selectedTab = vm.tabs[0];
        vm.dynamicCaseFields = sortBy(fieldResponse.data.viewFields, 'orderBy');
      });
    });
  }
};
</script>